import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_NAME } from "@shared/util/brand";

export default function StripeSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/asset/plan");
    }, 2500);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="relative bg-white dark:bg-gray-800 p-10 rounded-2xl text-center max-w-md w-full shadow-xl">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-green-200 flex items-center justify-center text-3xl">
          ✅
        </div>
        <h3 className="text-2xl font-semibold mb-3 dark:text-gray-100">
          Payment Successful!
        </h3>
        <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
          Thank you for your purchase. Your membership has been updated and you
          can now enjoy all features.
        </p>
        <button
          onClick={() => navigate("/asset/webinars")}
          className="w-full px-6 py-4 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg"
        >
          Go to the {APP_NAME} home page!
        </button>
      </div>
    </div>
  );
}
